var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewRequestButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.6693 12.8841V22.8841C36.6693 25.3841 35.8359 27.4675 34.3693 28.9341C32.9193 30.3841 30.8359 31.2174 28.3359 31.2174V34.7675C28.3359 36.1008 26.8526 36.9008 25.7526 36.1675L18.3359 31.2174H14.8026C14.9359 30.7174 15.0026 30.2008 15.0026 29.6675C15.0026 27.9675 14.3526 26.4008 13.2859 25.2175C12.0859 23.8508 10.3026 23.0008 8.33594 23.0008C6.46927 23.0008 4.76928 23.7675 3.55261 25.0175C3.40261 24.3508 3.33594 23.6341 3.33594 22.8841V12.8841C3.33594 7.88411 6.66927 4.55078 11.6693 4.55078H28.3359C33.3359 4.55078 36.6693 7.88411 36.6693 12.8841Z",
    stroke: "#081E54",
    strokeWidth: 1.57895,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9974 29.6667C14.9974 30.2 14.9307 30.7167 14.7974 31.2167C14.6474 31.8833 14.3808 32.5333 14.0308 33.1C12.8808 35.0333 10.7641 36.3333 8.33073 36.3333C6.61406 36.3333 5.06406 35.6833 3.89739 34.6166C3.39739 34.1833 2.96404 33.6667 2.63071 33.1C2.01404 32.1 1.66406 30.9167 1.66406 29.6667C1.66406 27.8667 2.38074 26.2167 3.5474 25.0167C4.76407 23.7667 6.46406 23 8.33073 23C10.2974 23 12.0807 23.85 13.2807 25.2167C14.3474 26.4 14.9974 27.9667 14.9974 29.6667Z",
    fill: "#A020FF",
    stroke: "#A020FF",
    strokeWidth: 2.10526,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8182 29.6367H5.85156",
    stroke: "white",
    strokeWidth: 1.57895,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33594 27.2031V32.1864",
    stroke: "white",
    strokeWidth: 1.57895,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8594 14.7852H27.1451",
    stroke: "#1552E8",
    strokeWidth: 1.47368,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8594 18.3594H27.1451",
    stroke: "#1552E8",
    strokeWidth: 1.47368,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewRequestButton);
export default __webpack_public_path__ + "static/media/NewRequestButton.a84de99edd14e0a1b207ce971fdf0f03.svg";
export { ForwardRef as ReactComponent };